import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, ViewChild } from '@angular/core';
import { ClientLogoItem } from '../../home.models';

@Component({
  selector: 'app-home-trust-carousel-section',
  standalone: true,
  templateUrl: './trust-carousel-section.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TrustCarouselSectionComponent {
  @ViewChild('logoSwiper') logoSwiper!: ElementRef<HTMLElement & { initialize: () => void }>;
  @ViewChild('prevBtn') prevBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild('nextBtn') nextBtn!: ElementRef<HTMLButtonElement>;

  @Input({ required: true }) clientLogos: ClientLogoItem[] = [];
}
